module.exports = __webpack_public_path__ + "media/gameChart.438fd9ef.mp4";